/** Skleja klasy CSS, pomijając wartości fałszywe. */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}
